import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=ca15b0da&"
import script from "./DetailTable.vue?vue&type=script&lang=js&"
export * from "./DetailTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports